import styled from 'styled-components';

export const Div = styled.div`
  display: inline;
  margin-left: 4px;
`;
